import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Auth from '../Auth/Auth';
import Select from 'react-select';

import _debounce from 'lodash/debounce';
import _map from 'lodash/map';
import _find from 'lodash/find';
import _trim from 'lodash/trim';
import _get from 'lodash/get';
import _template from 'lodash/template';
const currentServerURL = process.env.REACT_APP_serverURL;
const auth = new Auth();

const endpoint = _template(`${currentServerURL}/information/OperatorList?keywords=<%= string %>`);
const method = 'GET'

class SupplierCodeSelect extends Component {
	constructor(props) {
		super(props);
		this.onSelectInputChange = this.onSelectInputChange.bind(this);
		this.onSelectClick = this.onSelectClick.bind(this);

		this.state = {
			options: [],
			isSearching: false,
			currentObj: '',
		};
	}

	componentDidMount() {
		if (this.props.selectedSupplierCode) {
			this.getSupplierCodeLabel(this.props.selectedSupplierCode)
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			(prevProps.selectedSupplierCode !== this.props.selectedSupplierCode)
			&& (_get(this.state.currentObj, 'value') !== this.props.selectedSupplierCode)
		) {
			this.getSupplierCodeLabel(this.props.selectedSupplierCode)
		}
	}

	getSupplierCodeLabel(string) {
		if (string) {
			fetch(endpoint({'string' : _trim(string)}), {
				method: method,
				headers: {
					Authorization: 'Bearer ' + auth.getAccessToken(),
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
				.then(response => response.json())
				.then((result) => {
					if (result.length !== 0) {
						let options = _map(result, (r) => ({
							'value': r.operatorcode,
							'label': r.operatorcode + ' - ' + r.operatorname
						}))
						this.setState({
							currentObj: _find(options, {'value': _trim(string)})
						})
					}
				})
				.catch((error) => {
					console.log('error: ', error)
				});
		} else {
			this.clearLoginOptions()
		}

	}

	onSelectInputChange = _debounce((string, action) => {
		const act = action.action
		if (act === "input-change") {
			if (string) {
				this.setState({
					isSearching: true
				})

		    fetch(endpoint({'string' : string}), {
					method: method,
					headers: {
						Authorization: 'Bearer ' + auth.getAccessToken(),
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				})
					.then(response => response.json())
					.then((result) => {
						let options = _map(result, (r) => ({
							'value': r.operatorcode,
							'label': r.operatorcode + ' - ' + r.operatorname
						}))
						this.setState({
							options: options,
							isSearching: false
						})

					})
					.catch((error) => {
						console.log('error: ', error)
						this.setState({
							isSearching: false
						})
					});

			} else {
				this.clearLoginOptions()
			}
		}
	 }, 1000)

	onSelectClick(selectedOption) {
		if (selectedOption) {
			this.props.handleSelect(selectedOption.value, selectedOption.label)
			this.setState({
				currentObj: selectedOption
			})
		} else { // clear
			this.clearLoginOptions()
		}
	}

	clearLoginOptions() {
		if (this.props.isClearable) {
			this.setState({
				options: [],
				currentObj: ''
			});
			this.props.handleSelect('')
		}
	}

  render() {
		return (
			<Select
				name="typeCodeSelect"
				value={this.state.currentObj}
				onChange={this.onSelectClick}
				options={this.state.options ? this.state.options : []}
				onInputChange={(string, action) => this.onSelectInputChange(string, action)}
				placeholder="Search Supplier Code"
				isClearable={this.props.isClearable}
				isLoading={this.state.isSearching}
				className={this.props.isInvalid && "invalid-select"}
			/>
    );
  }
}

SupplierCodeSelect.propTypes = {
	isClearable: PropTypes.bool,
	handleSelect: PropTypes.func,
	selectedSupplierCode: PropTypes.string,
	isInvalid: PropTypes.bool,
}

export default SupplierCodeSelect;
